import { createAsyncThunk } from "@reduxjs/toolkit";

import { Api } from "../../api/index";
import {
  GeneralStatistic,
  CompanyStatistic,
  BuildingStatistic,
  WorkstationStatistic,
  EmployeeWithoutEventStatisticsResponse,
  TimeInSpaceEmployeeExitBeforeResponse,
} from "../../api/generated";
import { format } from "date-fns";

export const getWorkstationStatistics = createAsyncThunk(
  "getWorkstationStatistics",
  async (): Promise<WorkstationStatistic[]> => {
    return Api.Statistics.getWorkstationStatistics().then(({ data }) => {
      return data;
    });
  },
);

export const getStatistics = createAsyncThunk("getStatistics", async (): Promise<GeneralStatistic> => {
  return Api.Statistics.getGeneralStatistic().then(({ data }) => {
    return data;
  });
});

export const getCompaniesStatistics = createAsyncThunk(
  "getCompaniesStatistics",
  async (): Promise<CompanyStatistic[]> => {
    return Api.Statistics.getCompaniesStatistic().then(({ data }) => {
      return data;
    });
  },
);

export const getBuildingStatistics = createAsyncThunk(
  "getBuildingStatistics",
  async (): Promise<BuildingStatistic[]> => {
    return Api.Statistics.getBuildingsStatistic().then(({ data }) => {
      return data;
    });
  },
);

export const getAccessControlWithoutEventsStatistics = createAsyncThunk(
  "getAccessControlWithoutEventsStatistics",
  async (): Promise<EmployeeWithoutEventStatisticsResponse[]> => {
    return Api.Statistics.getEmployeesWithoutTodaysEventsUntilNow().then(({ data }) => {
      return data;
    });
  },
);

export const getEmployeesWithExitBefore = createAsyncThunk(
  "getEmployeesWithExitBefore",
  async ({
    startDate,
    endDate,
    targetLocalTime,
    buildingId,
  }: {
    startDate: Date;
    endDate: Date;
    targetLocalTime: string;
    buildingId: number;
  }): Promise<TimeInSpaceEmployeeExitBeforeResponse[]> => {
    const localStartStr = format(startDate, "yyyy-MM-dd");
    const localEndStr = format(endDate, "yyyy-MM-dd");
    return Api.Statistics.getEarlyExitsReports(localStartStr, localEndStr, targetLocalTime, buildingId).then(
      ({ data }) => {
        return data;
      },
    );
  },
);
